module.exports = __webpack_public_path__ + "assets/img/mecha-6f261bb9.png";